import { NavLink, Outlet } from "react-router-dom";
import { SectionLabel } from "@/components/ui/Card";

const ADMIN_NAV: Array<{ path: string; label: string; end?: boolean }> = [
  { path: "/admin", label: "Overview", end: true },
  { path: "/admin/users", label: "Users" },
  { path: "/admin/ai-spend", label: "AI Spend" },
  { path: "/admin/costs", label: "Costs" },
  { path: "/admin/waitlist", label: "Waitlist" },
  { path: "/admin/payments", label: "Payments" },
  { path: "/admin/system", label: "System" },
];

export default function AdminLayout() {
  return (
    <div className="mx-auto w-full max-w-7xl space-y-5 px-1 py-2">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <div>
          <SectionLabel>Control panel</SectionLabel>
          <h1 className="mt-1 font-serif text-[26px] font-medium">Admin</h1>
        </div>
        <div className="text-[11px] text-taupe">
          Superuser access · billing + operational telemetry
        </div>
      </div>

      <nav className="flex flex-wrap gap-1 border-b border-cream-border">
        {ADMIN_NAV.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.end}
            className={({ isActive }) =>
              `-mb-px border-b-2 px-3 py-2 text-[13px] transition-colors ${
                isActive
                  ? "border-amber text-navy-deep font-medium"
                  : "border-transparent text-taupe hover:text-navy-deep"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
